import { sanitize } from '@ben/common/dom';

export const decodeHtmlEntities = (input: string) => {
  const textArea = document.createElement('textarea');
  textArea.innerHTML = sanitize(input);
  return textArea.value;
};
